"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by tamara.aprikyan on 7/12/2017.
 */
var core_1 = require("@angular/core");
var sis_select_item_directive_1 = require("../shared/sis-select-item.directive");
var subscription_manager_decorator_1 = require("../shared/subscription-manager.decorator");
/**
 * BaseMenuComponent is base component for creating kendo menu.
 * TODO: Move this code/its tests to Menu and remove this.
 */
var BaseMenuComponent = /** @class */ (function () {
    function BaseMenuComponent() {
        this.overlapTrigger = false;
        this.onSelect = new core_1.EventEmitter();
        /**
         * The array of processed menu items convenient for rendering.
         * @type {Array<any>}
         */
        this.processedMenuItems = [];
    }
    /**
     * Sets content children parents and creates menu with this items.
     */
    BaseMenuComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.menuItems.forEach(function (menuItem) {
            menuItem.parent = _this;
            _this.processMenuItems(menuItem);
        });
        this.$sm = this.menuItems.changes.subscribe(function (changes) {
            _this.menuItems = changes;
            _this.onItemsChanged();
        });
    };
    /**
     * Processes the menu data to more convenient format for rendering.
     * @param {SelectItemDirective} menuItem - The child directive.
     * @protected
     */
    BaseMenuComponent.prototype.processMenuItems = function (menuItem) {
        var _this = this;
        // The case that menu item directive contains data not for single menu item, it contains data for multiple items.
        if (menuItem.data) {
            menuItem.data.forEach(function (dataItem) {
                _this.processedMenuItems.push({
                    text: dataItem[menuItem.nameField],
                    isDisabled: dataItem[menuItem.isEnabledField] && (!menuItem.isEnabled),
                    value: menuItem.valueField ? dataItem[menuItem.valueField] : dataItem,
                });
            });
        }
        else {
            this.processedMenuItems.push({
                text: menuItem.name,
                isDisabled: !menuItem.isEnabled,
                value: menuItem.value,
            });
        }
    };
    /**
     * Handler for menu item changes.
     */
    BaseMenuComponent.prototype.onItemsChanged = function () {
        var _this = this;
        this.processedMenuItems = [];
        this.menuItems.forEach(function (menuItemDirective) {
            menuItemDirective.parent = _this;
            _this.processMenuItems(menuItemDirective);
        });
    };
    /**
     * Event handler for menu item selection.
     * @param itemId
     */
    BaseMenuComponent.prototype.onItemClicked = function (itemId) {
        this.onSelect.emit(itemId);
    };
    BaseMenuComponent.prototype.trackByValue = function (index, item) {
        return item ? item.value : null;
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseMenuComponent.prototype, "title", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseMenuComponent.prototype, "icon", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], BaseMenuComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Boolean)
    ], BaseMenuComponent.prototype, "overlapTrigger", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], BaseMenuComponent.prototype, "onSelect", void 0);
    __decorate([
        core_1.ContentChildren(sis_select_item_directive_1.SelectItemDirective),
        __metadata("design:type", core_1.QueryList)
    ], BaseMenuComponent.prototype, "menuItems", void 0);
    BaseMenuComponent = __decorate([
        subscription_manager_decorator_1.SubscriptionManager(),
        __metadata("design:paramtypes", [])
    ], BaseMenuComponent);
    return BaseMenuComponent;
}());
exports.BaseMenuComponent = BaseMenuComponent;
//# sourceMappingURL=sis-base-menu.component.js.map